import { Button } from '@kc-console/common-ui';
import { IcRssRegular } from '@kep/kcds-icons';

import { useRegionEndpoint } from '@/shared/hooks';

/**
 * RSS Feed 링크를 새 창으로 여는 버튼.
 * @description
 * - 현재 접속 중인 사이트의 origin에 `/rss/events-kr-central-2.xml` 경로를 붙여 새 탭으로 이동한다.
 * @example
 * <RssFeedButton />
 */
const RssFeedButton = () => {
  const { currentRegion } = useRegionEndpoint();
  const handleClick = () => {
    window.open(
      `${window.location.origin}/rss/events-${currentRegion}.xml`,
      '_blank',
      'noopener noreferrer',
    );
  };

  return (
    <Button
      variant="primary"
      size="lg"
      startIcon={<IcRssRegular fontSize={20} />}
      onClick={handleClick}
    >
      RSS 피드
    </Button>
  );
};

export default RssFeedButton;
